export const MONTHS = 12
export const INTEREST_TO_DECIMAL = 100

export enum DebtPriority {
  FASTEST_PAYOFF_FIRST = 1,
  HIGHEST_INTEREST = 2,
  LOWEST_BALANCE = 3,
  HIGHEST_BALANCE = 4,
}
